import { useState, useEffect } from "react";
import API from "../../services/API";
import Layout from "../Frames/Layout";
import Loader from "../Tools/Loader";
import { useContext } from "react";
import UserContext from "../../services/Context/UserContext";
import { Button, Stack} from "@mui/material";
import Search from "./Search";
import Card from "./Card";
import { txt } from "../../services/translation";

export default function Courses(){

    const {user} = useContext(UserContext)

    const [courses, setCourses] = useState(null);
    const [search, setSearch] = useState({
        fast: '', 
        category: user.category,
        tag: null,
        badge: 'all',
        order: 'date',
        owner: '84264658000022',
        kind: 'elearning'
    });
    const [limit, setLimit] = useState(10)


    useEffect(() => {

        API.get('/courses?type=course')
            .then(r => setCourses(r.data))

    }, [])


    const match = i => (i.title + i.teachers).toLowerCase().includes(search.fast.toLowerCase())
        && (!search.category || i.categories.concat(i.category.id).includes(search.category?.id))
        && (!search.tag || i.keyWords.includes(search.tag?.title))
        && (['all','pi'].includes(search.badge) || i.badges.includes(search.badge))
        && (search.badge === 'pi' ? i.pi : true)
        && (['all',i.siret.toString()].includes(search.owner))
        && i.kind?.id === search.kind

    
    const compare = (a,b) => {
        if(search.order === 'date') return b.createdAt > a.createdAt ? 1 : -1;
        if(search.order === 'rating') return b.reviews.average > a.reviews.average ? 1 : -1;
        if(search.order === 'title') return a.title > b.title ? 1 : -1;
    }


    const items = (courses || [])
        .filter(c => match(c))
        .sort((a,b) => compare(a,b))

    
     return <Layout title={txt('trainingCatalogTitle')} tab="courses" menu="main">

        <Stack spacing={1}>
    
            <Search
                value={search}
                onChange={value => setSearch(value)}
            />
    
            <Stack direction='row' flexWrap='wrap'>
    
                {items.slice(0, limit).map(c => 
                    <Card 
                        course={c} 
                        key={c.id}
                    />
                )}
    
            </Stack>
    
            {items.length > limit &&
                <Button
                    size='large'
                    onClick={() => setLimit(limit + 10)}
                >
                    {txt('showMoreButton')}
                </Button>
            }
    
        </Stack>
    
        {!courses && <Loader />}
    
    </Layout>
    

}